import React, { useState, useEffect } from "react"
import { Modal, Button, Icon, Container, Grid, Message } from 'semantic-ui-react';
import jsPDF from 'jspdf';
import {getCompanyCollection, getCompanyDocument} from '../../firebase';

const Payment = ({rol, empMensual, empAnual, onModalSubmit, ultimoPago}) => {
    const totalEmpleados = 1 + empMensual + empAnual;
    const [cutDay, setCutDay] = useState(0);
    const [lastPayment, setLastPayment] = useState(null);
    const paymentAmount = (empMensual * 80) + (empAnual * 75 * 12);
    const currentDate = new Date();
    let nextPaymentDate = new Date(currentDate);
    nextPaymentDate.setDate(cutDay);
    
    if (currentDate.getDate() >= cutDay) {
        nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1);
    }
    const editarEmpleadosMax =()=>{
        if (rol === "admin"){
            return(
                <EditarEmpleadosMax 
                onModalSubmit={onModalSubmit}
                empMensual={empMensual}
                empAnual={empAnual}
            />)
        }
    }
    const handlePayment = () => {
        setLastPayment(currentDate);
        setCutDay(0); // Reset cutDay to 0
        nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1); // Move nextPaymentDate to the next month
    };
        
    return (
    <>
        <section className='settingsCard'>
            <div className='settingsCardHeader'>
                <div>
                    <h2>Capacidad de empleados</h2>
                    <p>Consulta y administra los lugares disponibles en tu plan.</p>
                </div>
                {editarEmpleadosMax()}
            </div>
            <div className='settingsMetrics'>
                <div className='settingsMetric settingsMetricPrimary'><strong>{totalEmpleados}</strong><span>Empleados activos</span></div>
                <div className='settingsMetric'><strong>1</strong><span>Incluido sin costo</span></div>
                <div className='settingsMetric'><strong>{empMensual}</strong><span>Pago mensual</span></div>
                <div className='settingsMetric'><strong>{empAnual}</strong><span>Pago anual</span></div>
            </div>
        </section>
        <section className='settingsCard settingsBillingCard'>
            <div className='settingsCardHeader'>
                <div>
                    <h2>Suscripción y pagos</h2>
                    <p>Resumen del siguiente cobro de tu cuenta.</p>
                </div>
            </div>
            <div className='settingsBillingDetails'>
                <div><span>Fecha de corte</span><strong>{ultimoPago ? ultimoPago.toDate().toLocaleDateString() : 'Sin pagos anteriores'}</strong></div>
                <div><span>Próximo pago</span><strong>${paymentAmount} + IVA</strong></div>
                <div><span>Límite de pago</span><strong>{nextPaymentDate.toLocaleDateString()}</strong></div>
            </div>
            <div className='settingsBillingFooter'>
                <span>Último pago: {lastPayment ? lastPayment.toLocaleDateString() : 'Falta primer pago'}</span>
                <button className='settingsPayButton' onClick={()=>handlePayment()}>Pagar</button>
            </div>
        </section>
    </>
    );
}
const EditarEmpleadosMax =( {onModalSubmit, empMensual, empAnual})=>{
    const [empMensualNew, setEmpMensual] = useState(empMensual);
    const [empAnualNew, setEmpAnual] = useState(empAnual);
    const [openModal, setOpenModal] = useState(false);
    const [activeEmp, setactiveEmp] = useState(0);
    const [pagarMen, setPagarMen] = useState(0);
    const [pagarAnu, setPagarAnu] = useState(0);
    const [message, setMessage] = useState('');
    const [boton, setBoton] = useState(true);
    const [botonTxt, setBotonTxt] = useState('Enviar');

    useEffect(()=>{
        // El primer empleado es gratuito. Los valores mensual y anual
        // representan solamente los lugares adicionales contratados.
        let totalAnt = 1+empAnual+empMensual
        let totalNew = 1+empAnualNew+empMensualNew
        if (empMensualNew-empMensual > 0) {
            setPagarMen(80*(empMensualNew-empMensual))
        } else {
            setPagarMen(0)
        }
        if (empAnualNew-empAnual > 0){
            setPagarAnu(75*12*(empAnualNew-empAnual))
        } else {
            setPagarAnu(0)
        }
        if (activeEmp-totalNew > 0){
            setMessage('Desactive empleados para poder reducir el máximo.')
            setBotonTxt("Enviar")
            setBoton(true)
        }else if (pagarMen+pagarAnu > 0){
            setMessage('Pago total= $'+(pagarMen+pagarAnu)+' +IVA')
            setBotonTxt("Pagar")
            setBoton(false)
        }else if (totalAnt > totalNew){
            setMessage('la reducción se verá reflejada en el próximo corte.')
            setBotonTxt("Enviar")
            setBoton(false)
        }else {
            setMessage('')
            setBotonTxt("Enviar")
            setBoton(true)
        }
    },[empAnualNew, empMensualNew, activeEmp,empAnual,empMensual, pagarMen, pagarAnu])

    const fetchCount = async () => {
        try {
            const dbEmp = await getCompanyCollection('Empleados');
            const query = dbEmp.where('activo', '==', 'si');
            const querySnapshot = await query.get();
            setactiveEmp(querySnapshot.size);
        } catch (error) {
            console.error('Error getting documents:', error);
        }
    }
    fetchCount()
    const handleSave = async () => {
      const company = await getCompanyDocument()
      await company.update({
        empMensual: empMensualNew,
        empAnual: empAnualNew,
    }).then(()=> {
        console.log("Document successfully written!");
        onModalSubmit()
        alert("Datos Guardados")
    })
      setOpenModal(false)
      setEmpMensual(empMensual)
      setEmpAnual(empAnual)
    }
    const handleEmpMensual = (e) => {
        const inputValue = e.target.value
        if (/^\d*\.?\d*$/.test(inputValue)) {
            setEmpMensual(parseInt(inputValue));
        }
    }
    const handleEmpAnual = (e) => {
        const inputValue = e.target.value
        if (/^\d*\.?\d*$/.test(inputValue)) {
            setEmpAnual(parseInt(inputValue));
        }
    }
    const generatePDF = () => {
        const doc = new jsPDF();
    
        // Add content to the PDF
        doc.text('Invoice', 10, 10);
        doc.text(`Empleados nuevos: ${empMensualNew}`, 10, 20);
        doc.text('Bank Transfer Details:', 10, 30);
        doc.text('Account Name: Your Account Name', 10, 40);
        doc.text('Account Number: 1234567890', 10, 50);
        doc.text('Bank Name: Your Bank Name', 10, 60);
        doc.text('IFSC Code: ABCD1234', 10, 70);
        doc.text(`Total: $${pagarMen+pagarAnu}`, 10, 80);
    
        // Save the PDF
        doc.save('invoice.pdf');
    };
  
    return (
      <label>
      <button className='editar' onClick={()=>setOpenModal(true)}>
        <Icon name='edit' />
      </button>
      <Modal 
          open={openModal}
          onOpen={()=>setOpenModal(true)}
          onClose={()=>setOpenModal(false)}
      >
        <Modal.Header>
          <Container textAlign="center">
            Editar el máximo de empleados
          </Container>
        </Modal.Header>
            <Message>
                <p>Empleados activos = {activeEmp}</p>
            </Message>
        <Modal.Content>
          <Grid columns={2} divided >
              <Grid.Row>
                  <Grid.Column>
                    <Container textAlign='right'>Pago empleado mensual:</Container>
                  </Grid.Column>
                  <Grid.Column>
                    <Container textAlign='left'>
                        Actual: {empMensual+" "}
                        Nuevo:
                        <input
                        style={{width: "3em"}}
                        type="number"
                        value={empMensualNew}
                        onChange={handleEmpMensual} 
                        min="0"
                        />
                    </Container>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                  <Grid.Column>
                    <Container textAlign='right'>Pago empleado anual:</Container>
                  </Grid.Column>
                  <Grid.Column>
                    <Container textAlign='left'>
                        Actual: {empAnual+" "}
                        Nuevo:
                        <input 
                        style={{width: "3em"}}
                        type="number"
                        value={empAnualNew}
                        onChange={handleEmpAnual} 
                        min="0"
                        />
                    </Container>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                  <Grid.Column>
                    <Container textAlign='right'>Total:</Container>
                  </Grid.Column>
                  <Grid.Column>
                    <Container textAlign='left'>
                        Actual: {(1+empMensual+empAnual)+" "}
                        Nuevo: {(1+empMensualNew+empAnualNew)}
                    </Container>
                </Grid.Column>
              </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
            {message}
          <Button primary onClick={()=>generatePDF()} disabled={boton} >
            {botonTxt}
          </Button>
        </Modal.Actions>
      </Modal>
      </label>
    )
  }

export default Payment;
